module.exports = __webpack_public_path__ + "img/exam1.f66c9c3b.png";